<template>
<div>
<v-app>
<resizable-page>
  <template v-if="option_warehouse" v-slot:table="tableProps">
  <v-card>
    <!-- <v-card-title>
      Driver List
    </v-card-title> -->
    <v-card-title>
      
        <v-menu
        :key="componentKeyMenuRange"
        ref="menu_range"
        v-model="menu_range"
        :close-on-content-click="false"
        :return-value.sync="date_range_list"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="auto"
      >
        
        <template v-slot:activator="{ on, attrs }">
          <v-select
          style=" max-width: 150px; padding-bottom: 20px;"
            :items="option_warehouse"
            label="Select Warehouse"
            v-model="warehouse"
            @change="getList"
            item-text="warehouse_name"
            item-value="id"
          
            class="ma-2"
          hide-details
        >
        </v-select>
          <v-text-field
          :disabled="!warehouse"
            v-model="date_range_list_show"
            label="Date Range"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
            class="shrink"
          ></v-text-field>
        </template>
        <v-date-picker 
          
          v-model="date_range_list"
          range
          no-title
          scrollable
          show-adjacent-months
          :show-current="date_list"
        >
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="menu_range = false"
          >
            Cancel
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="$refs.menu_range.save(date_range_list);changeDateRange();"
          >
            OK
          </v-btn>
        </v-date-picker>
      </v-menu>
        <v-menu>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            class="ma-2"
            v-bind="attrs"
            v-on="on"
          >
            Export To XLS
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <downloadExcel
                    :data="dataExport(table)"
                    :fields="field_export"
                    :worksheet="worksheetName"
                    :name="fileName"
                    :fetch= "()=>{return dataExportBefore('all')}"
                    
                  >
                    All Record
             </downloadExcel>
          </v-list-item>
          <v-list-item>
            <downloadExcel
                    :data="exportDisplayedPage"
                    :fields="field_export"
                    :worksheet="worksheetName"
                    :name="fileName"
                  >
                    Displayed record
             </downloadExcel>
          </v-list-item>
          <v-list-item>
            <downloadExcel
                    :data="exportAllFitered"
                    :fields="field_export"
                    :worksheet="worksheetName"
                    :name="fileName"
                    :fetch= "()=>{return dataExportBefore('filter')}"
                  >
                    All filtered record
                  </downloadExcel>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <div class="d-flex">
        <v-select
        style=" max-width: 150px;"
          :items="option_filter"
          label="Select"
          v-model="searchCategory"
          @change="search=''"
           item-text="text"
          item-value="value"
        
          class="ma-2"
        hide-details
        >
        </v-select>
      <v-text-field
        :disabled="!searchCategory"
        v-model="search"
        label="Search"
          class="ma-2"
        single-line
        hide-details
      >
      </v-text-field>
        <v-btn :disabled="!search" class="mt-5"  small color="primary" @click="searchButton"> <v-icon>mdi-magnify</v-icon> </v-btn>
        <v-btn v-if="searchValue" class="mt-5 ml-1" dark small color="red" @click="clearSearchButton">Clear</v-btn>
    </div>
      <!-- <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field> -->
    </v-card-title>
    <!-- <v-data-table
      :headers="headers"
      :items="table"
      :search="search"
      :loading="loadTable"
      loading-text="Loading... Please wait"
      @current-items="getFiltered"
      ref="vTable"
      :height="tableProps.tableHeight"
      fixed-header
      :footer-props="{'items-per-page-options':[5,15, 30, 50, 100, -1]}"
      :options="{'itemsPerPage':50}" 
    > -->
    <v-data-table
      mobile-breakpoint
      :headers="headers"
      :items="table"
      
      :loading="loadTable"
      loading-text="Loading... Please wait"
      @current-items="getFiltered"
      ref="vTable"
      :height="tableProps.tableHeight"
      fixed-header
      :options.sync="options"
      :server-items-length="totalDataTable"
      :page="page"
      :pageCount="numberOfPages"
      single-expand
      show-expand
      :footer-props="{'items-per-page-options':[5,15, 30, 50, 100]}"
    >

    <template v-slot:[`header.spare_part_master_type`]="{ header }">
           <v-select
                style=" font-size:10px;"
                :items="optionFilterType"
                :label="header.text"
                v-model="valueFilterType"
                @change="getList"
                item-text="text"
                item-value="value"
              
                class="ma-2"
              hide-details
              >
            </v-select>
         </template>

     <template v-slot:[`header.spare_part_master_category`]="{ header }">
           <v-select
                style=" font-size:10px;"
                :items="optionFilterCategory"
                :label="header.text"
                v-model="valueFilterCategory"
                @change="getList"
                item-text="text"
                item-value="value"
              
                class="ma-2"
              hide-details
              >
            </v-select>
         </template>
    <template v-slot:[`item.spare_part_master_type`]="{ item }">
       <span v-if="item.spare_part_master_type == 1">Spare Part</span>
       <span v-else-if="item.spare_part_master_type == 2">Material</span>
       <span v-else-if="item.spare_part_master_type == 3">Not Spare Part & Material</span>
     </template>
     <template v-slot:[`item.spare_part_master_category`]="{ item }">
       <span v-if="item.spare_part_master_category == 1">Fast Moving</span>
       <span v-else-if="item.spare_part_master_category == 2">Slow Moving</span>
     </template>
     <template v-slot:[`item.spare_part_master_unit_price`]="{ item }">
      <span style="float: left; ">Rp.</span><span style="float:right;">{{
                formatPrice(item.spare_part_master_unit_price)
              }}</span>
     </template>
     <template v-slot:[`item.spare_part_master_alert_price`]="{ item }">
      <span style="float: left; ">Rp.</span><span style="float:right;">{{
                formatPrice(item.spare_part_master_alert_price)
              }}</span>
     </template>
    <template  v-slot:expanded-item="{ headers, item }">
      <td class="pa-5" :colspan="headers.length">
      Stock Detail:
      <md-table class="ma-5">
        IN
                        <md-table-row >
                            <md-table-head style="text-align: center;"><b>PO No./Transfer In no.</b></md-table-head>
                            <md-table-head style="text-align: center;"><b>Date</b></md-table-head>
                            <md-table-head style="text-align: center;"><b>Amount</b></md-table-head>
                            
                        </md-table-row>
                         <md-table-row  v-for="(items, index)  in item.stock_in_ref" :key="index">
                                <md-table-cell style="text-align: center;">
                                  <!-- <router-link :to="{name: 'List Procurement Order', params: { id: items.id }}" class="btn btn-primary">{{items.procurement_order_no}}
                                  </router-link> -->
                                  <a v-if="items.type == 1"  @click="modalOpenShowPo(items.id)">{{items.procurement_order_no}}</a>
                                  <a v-else-if="items.type == 3"  @click="modalOpenShowTransfer(items.id)">{{items.spare_part_transfer.spare_part_transfer_no}}</a>
                                </md-table-cell>
                                <md-table-cell style="text-align: center;">{{items.date_in}}</md-table-cell>
                                <md-table-cell style="text-align: center;">{{items.item_amount}}</md-table-cell>
                         </md-table-row>
                    </md-table>
        <md-table class="ma-5">
          OUT
                        <md-table-row >
                            <md-table-head style="text-align: center;"><b>Nota Part No./Transfer Out no.</b></md-table-head>
                            <md-table-head style="text-align: center;"><b>Date</b></md-table-head>
                            <md-table-head style="text-align: center;"><b>Amount</b></md-table-head>
                            
                        </md-table-row>
                         <md-table-row v-for="(items, index)  in item.stock_out_ref" :key="index">
                                <md-table-cell style="text-align: center;">
                                 
                                  <!-- <router-link :to="{name: 'List Nota Part', params: { id: items.id }}" class="btn btn-primary">{{items.nota_part_no}}
                                  </router-link> -->
                                  <a v-if="items.type == 2"  @click="modalOpenShowNotaPart(items.id)">{{items.nota_part_no}}</a>
                                  <a v-else-if="items.type == 4"  @click="modalOpenShowTransfer(items.id)">{{items.spare_part_transfer.spare_part_transfer_no}}</a>
                                  </md-table-cell>
                                <md-table-cell style="text-align: center;">{{items.date_out}}</md-table-cell>
                                <md-table-cell style="text-align: center;">{{items.item_amount}}</md-table-cell>
                         </md-table-row>
                    </md-table>
      </td>
    </template>
    </v-data-table>
  </v-card>
    </template>
  </resizable-page>
  </v-app>
  <modal ref="modalShowNotaPart">
    <template v-slot:body >
      <detail-nota-part :data_id="$refs.modalShowNotaPart.data" />
    </template>
  </modal>
  <modal ref="modalShowPo">
    <template v-slot:body >
      <detail-po :data_id="$refs.modalShowPo.data" />
    </template>
  </modal>
  <modal ref="modalShowTransfer">
    <template v-slot:body >
      <detail-transfer :data_id="$refs.modalShowTransfer.data" />
    </template>
  </modal>
</div>
</template>

<script>
import vuetify from '@/plugins/vuetify'
import Swal from "sweetalert2";
import JsonExcel from "vue-json-excel";
import DetailNotaPart from "@/pages/Dashboard/Workshop/NotaPart/DetailNPPage.vue";
import DetailPO from "@/pages/Dashboard/Workshop/ProcurementOrder/DetailPOPage.vue";
import DetailTransfer from "@/pages/Dashboard/Workshop/SparePartTransfer/DetailSPTPage.vue";
import { ResizablePage,Modal } from "@/components";

  export default {
    components: {
    downloadExcel: JsonExcel,
    ResizablePage, 
    Modal,
    "detail-nota-part" : DetailNotaPart,
    "detail-po" : DetailPO,
    "detail-transfer" : DetailTransfer
  },
    vuetify,
    data () {
      return {
        componentKeyMenuRange: 0,
        menu: false,
      menu_range: false,
      modal: false,
      warehouse: null,
      option_warehouse: null,
        date_list: null,
        date_range_list: null,
        date_list_show: null,
        date_range_list_show: null,
        mounted:true,
        loadTable: false,
        page: 1,
        options: {},
        totalDataTable: 0,
        numberOfPages: 0,
        searchValue:null,
        searchCategory:null,
        option_filter: [ 
          { text: 'Part/Material Category', value: 'spare_part_master_caetgory' },
          { text: 'Part/Material Code', value: 'spare_part_master_code'},
          { text: 'Part/Material Name', value: 'spare_part_master_name'}
          ],
         optionFilterType: [ 
          { text: 'All', value: 0 },
          { text: 'Spare Part', value: 1 },
          { text: 'Material', value: 2}
            ],
          valueFilterType: 0,
         optionFilterCategory: [ 
          { text: 'All', value: 0 },
          { text: 'Fast Moving', value: 1 },
          { text: 'Slow Moving', value: 2}
            ],
          valueFilterCategory: 0,
        role: "",
        search: '',
         headers: [
          {
            text: 'Type',
            align: 'start',
            value: 'spare_part_master_type',
            sortable: false
          },
          { text: 'Part/Material Category', value: 'spare_part_master_category',
            sortable: false },
          { text: 'Part/Material Code', value: 'spare_part_master_code' },
          { text: 'Part/Material Name', value: 'spare_part_master_name' },
          { text: 'Unit', value: 'spare_part_master_unit' , align: 'center'},
          { text: 'Trace Hold', value: 'spare_part_master_threshold', align: 'center' },
          { text: 'Stock Begining', value: 'stock_begining', align: 'center' },
          { text: 'Stock In', value: 'stock_in', align: 'center' },
          { text: 'Stock Out', value: 'stock_out', align: 'center' },
          { text: 'Stock Ending', value: 'stock_ending' , align: 'center'},
          { text: 'Detail', value: 'data-table-expand' },
        ],
        table: [],
        worksheetName: "Stock Sparepart Audit ",
        fileName:"Stock Sparepart Audit.xls",
        exportDisplayedPage:[],
        exportAllFitered:[],
        field_export: {
         'no': 'no',
          'spare_part_master_code' : 'spare_part_master_code',
          'spare_part_master_name' : 'spare_part_master_name',
          'spare_part_master_unit' : 'spare_part_master_unit',
          'spare_part_master_type' : 'spare_part_master_type',
          'spare_part_master_category' : 'spare_part_master_category',
          'spare_part_master_threshold' : 'spare_part_master_threshold',
          'spare_part_master_stock_begining' : 'spare_part_master_stock_begining',
          'spare_part_master_stock_in' : 'spare_part_master_stock_in',
          'spare_part_master_stock_out' : 'spare_part_master_stock_out',
          'spare_part_master_stock_ending' : 'spare_part_master_stock_ending',
          'no_in': 'no_in',
          'po_no': 'po_no',
          'date_in': 'date_in',
          'amount_in': 'amount_in',
          'no_out': 'no_out',
          'nota_part_no': 'nota_part_no',
          'date_out': 'date_out',
          'amount_out': 'amount_out',
        },
      }
    },
 

    watch:{
    date_range_list: function(nv, ov) {
      console.log(nv)
      if(nv){
        this.date_range_list_show = nv.join(' ~ ')
      }
      else{
        this.date_range_list_show = ""
      }
    },
    options: {
      handler() {
        if( !this.mounted){
          this.getList();
        }
      },
    },
    deep: true,
  },
    async mounted() {
      //get list role dan permission current user 
      this.role = await this.$store.getters["role_permission/route_filter"];
      await this.$store.dispatch("workshop_warehouse/list")
      this.option_warehouse = await this.$store.getters["workshop_warehouse/list"];
      console.log(this.option_warehouse);
    this.getList();
    this.mounted = false

    },
     methods: {
       // ambil data yang dibutuhkan
    async getList() {
     
      if(this.date_range_list == null){
        return
      }
      this.loadTable= true
      const { page, itemsPerPage,sortBy,sortDesc } = this.options;
      console.log(this.options)
      let pageNumber = page;
      
      
      var query = {"page":{number:pageNumber,size:itemsPerPage}}
      
      query.filter = {warehouse:this.warehouse}
      Object.assign(query.filter, {['audit']:this.date_range_list.toString()});
      if(sortBy.length!=0){
        var  sort=sortBy[0]
        if(sortDesc[0]){
          sort="-"+sortBy[0]
        }
        query.sort = sort
      }

      if(this.searchValue && this.searchCategory){
        Object.assign(query.filter, {[this.searchCategory]:this.searchValue});
      }

      if(this.valueFilterType!=0){
          Object.assign(query.filter, {spare_part_master_type:this.valueFilterType});
      }

      if(this.valueFilterCategory!=0){
          Object.assign(query.filter, {spare_part_master_category:this.valueFilterCategory});
      }
     
      await this.$store.dispatch("workshop_spare_part_master/list",query);
      // if (
      //   (await this.$store.getters["role/list"]) &&
      //   (await this.$store.getters["role/list"].length) != 0
      // ) { 
        this.table = await this.$store.getters["workshop_spare_part_master/list"];
        var pageMeta  = await this.$store.getters["workshop_spare_part_master/page"];
      // }
      // else{
      //   this.table = []
      // }
      this.totalDataTable = pageMeta.total
      this.numberOfPages = pageMeta['to']
      this.loadTable= false
      this.loadTable= false
    },

    changeDateRange(){
      this.getList()
      
        this.worksheetName= "Stock Sparepart Audit "+ this.date_range_list_show
        this.fileName="Stock Sparepart Audit "+ this.date_range_list_show +".xls"
    },

    clear_date_range() {
       this.componentKeyMenuRange += 1;
       this.date_range_list=null
       this.date_range_list_show=null
    },
      // format merubah angka ke currency 
    formatPrice(value) {
        let val = (value/1).toFixed().replace('.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },

    searchButton(){
       this.options.page = 1;
      this.searchValue = this.search
      this.getList()
    },
    clearSearchButton(){
       this.options.page = 1;
      this.searchValue = null
      this.search = null
      this.searchCategory = null
      this.getList()
    },

    modalOpenShowNotaPart(id){
      //kirim id po dan ref modal agar dapat di close langsung dari modal
      this.$refs.modalShowNotaPart.openModal({id:id,modal_ref:this.$refs.modalShowNotaPart})
    },


    modalOpenShowTransfer(id){
      //kirim id transfer dan ref modal agar dapat di close langsung dari modal
      this.$refs.modalShowTransfer.openModal({id:id,modal_ref:this.$refs.modalShowTransfer})
    },
   

    modalOpenShowPo(id){
      //kirim id po dan ref modal agar dapat di close langsung dari modal
      this.$refs.modalShowPo.openModal({id:id,modal_ref:this.$refs.modalShowPo})
    },

    getFiltered(data){
    this.exportDisplayedPage = this.dataExport(data)
    // if(this.$refs.vTable){
    //   this.exportAllFitered = this.dataExport(this.$refs.vTable.$children[0].filteredItems)
    // }
    // else{
    //   this.exportAllFitered = this.dataExport(this.table)
    // }
    },

    async dataExportBefore(type){
      if(this.table.length!=0){
        
        var query = {}
         query.filter = {audit:this.date_range_list.toString()}

          // const { page, itemsPerPage,sortBy,sortDesc } = this.options;
          // if(sortBy.length!=0){
          //   var  sort=sortBy[0]
          //   if(sortDesc[0]){
          //     sort="-"+sortBy[0]
          //   }
          //   query.sort = sort
          // }

        if(type=="all"){

        }
        else if(type=="filter"){

          
                if(this.searchValue && this.searchCategory){
                  Object.assign(query.filter, {[this.searchCategory]:this.searchValue});
                }

                if(this.valueFilterType!=0){
                    Object.assign(query.filter, {spare_part_master_type:this.valueFilterType});
                }

                if(this.valueFilterCategory!=0){
                    Object.assign(query.filter, {spare_part_master_category:this.valueFilterCategory});
                }
        }
         await this.$store.dispatch("workshop_spare_part_master/list",query);
         return this.dataExport(await this.$store.getters["workshop_spare_part_master/list"]);
      }
      
    },

    //fungsi untuk mengubah data yang siap di export data ke xls, saat dipanggil di awal dan dipanggil berulang kali di fungsi filter
      dataExport(data){
      // return data.map((v,index) => ({...v, no: index+1}))
      var dataReturn=[]
        data.forEach((value_1, index_1) => {
            var type= null
            var category= null
              
              if(value_1.spare_part_master_type == 1){
              type = "Spare Part"
              }
              else if(value_1.spare_part_master_type == 2){
                  type = "Material"
              }

              if(value_1.spare_part_master_category == 1){
                  category = "Fast Moving"
              }
              else if(value_1.spare_part_master_category == 2){
                  category = "Slow Moving"
              }
              if(value_1.stock_in_ref.length!=0 || value_1.stock_out_ref.length!=0){

              
              for (let i = 0;  i < Math.max(value_1.stock_in_ref.length, value_1.stock_out_ref.length); i++) {
                   var data= {
                          no:  dataReturn[index_1] && dataReturn[index_1].no == index_1+1 ? null : index_1+1,
                          spare_part_master_code : value_1.spare_part_master_code,
                          spare_part_master_name : value_1.spare_part_master_name,
                          spare_part_master_unit : value_1.spare_part_master_unit,
                          spare_part_master_type : type,
                          spare_part_master_category : category,
                          spare_part_master_threshold : value_1.spare_part_master_threshold,
                          spare_part_master_stock_begining : value_1.stock_begining,
                          spare_part_master_stock_in : value_1.stock_in,
                          spare_part_master_stock_out : value_1.stock_out,
                          spare_part_master_stock_ending : value_1.stock_ending,
                          no_in: value_1.stock_in_ref[i]? i+1 : null,
                          po_no: value_1.stock_in_ref[i]? value_1.stock_in_ref[i].procurement_order_no : null,
                          date_in: value_1.stock_in_ref[i]? value_1.stock_in_ref[i].date_in : null,
                          amount_in: value_1.stock_in_ref[i]? value_1.stock_in_ref[i].item_amount : null,
                          no_out: value_1.stock_out_ref[i]? i+1 : null,
                          nota_part_no: value_1.stock_out_ref[i]? value_1.stock_out_ref[i].nota_part_no : null,
                          date_out: value_1.stock_out_ref[i]? value_1.stock_out_ref[i].date_out : null,
                          amount_out: value_1.stock_out_ref[i]? value_1.stock_out_ref[i].item_amount : null,

                        }
                    

                  
                      dataReturn.push(data)
                    } 
                }
                else{
                  var data= {
                          no:  index_1+1,
                          spare_part_master_code : value_1.spare_part_master_code,
                          spare_part_master_name : value_1.spare_part_master_name,
                          spare_part_master_unit : value_1.spare_part_master_unit,
                          spare_part_master_type : type,
                          spare_part_master_category : category,
                          spare_part_master_threshold : value_1.spare_part_master_threshold,
                          spare_part_master_stock_begining : value_1.stock_begining,
                          spare_part_master_stock_in : value_1.stock_in,
                          spare_part_master_stock_out : value_1.stock_out,
                          spare_part_master_stock_ending : value_1.stock_ending,
                        

                        }
                    

                  
                      dataReturn.push(data)
                }
                

        });
       return dataReturn
      
     
      }
     },
  }
</script>
<style>
.v-application--wrap {
  min-height: unset;
}
.v-list-item__title {
    font-size: 0.8rem;
}
</style>